import { v4 as uuidv4 } from 'uuid';

/**
 * Returns a 16 character string of numbers
 *
 * @return string
 */
export default () => uuidv4();
